import { Injectable } from '@angular/core';
import { AuthService } from '../api/auth.service';
import { RoutesService } from '../api/routes.service';
import { LoginCtrl } from './login-ctrl';
import { LoginGuardService } from '../api/login-guard.service';

@Injectable({
  providedIn: 'root'
})

export class LoginValidationService {

  constructor(
    private auth: AuthService,
    private routes: RoutesService,
    private loginGuard: LoginGuardService
  ) {

  }
  initCtrl(){
   return new LoginCtrl(this.auth, this.routes, this.loginGuard);
  }
 
}
